import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard para proteger rutas que requieren autenticación
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Si ya está autenticado, permitir
  if (authService.isAuthenticated()) {
    return true;
  }

  // Intentar inicializar (refresh + carga de datos) antes de rechazar
  return authService.initializeSession().then((ok) => {
    if (ok) return true;
    router.navigate(['/']);
    return false;
  });
};
